import {alias, createModelSchema, identifier, reference,} from "serializr";
import {Cloneable} from "@/common/Cloneable";
import {Schema} from "@/common/Schema";

export class AvatarStatus extends Cloneable {
    static LOCKED = new AvatarStatus(0, "LOCKED")

    static _values = [
        this.LOCKED,
        new AvatarStatus(2, "UNLOCKED")
    ];

    static getValues() {
        return AvatarStatus._values;
    }

    static getValue(id) {
        let value = AvatarStatus._values.find(v => v.id === id) || null;
        console.assert(value, "unknown model: " + id);
        return value;
    }

    static schema() {
        return reference("id", (id, cb) => {
            return cb(null, AvatarStatus.getValue(id));
        });
    }

    static is(value) {
        if (value instanceof AvatarStatus) {
            return AvatarStatus._values.some(v => v.id === value.id);
        } else {
            return false;
        }
    }

    static isNone(value) {
        return AvatarStatus.NONE.equal(value);
    }

    constructor(id = 0, name = "LOCKED") {
        super();
        this._id = id;
        this._name = name;
    }

    get id() {
        return this._id;
    }

    get name() {
        return this._name;
    }

    equal(value) {
        if (value instanceof AvatarStatus) {
            return this.id === value.id;
        }
        return false;
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new AvatarStatus());
        } else if (target instanceof AvatarStatus) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(AvatarStatus, {
    _id: alias("id", identifier()),
    _name: alias("name", Schema.primitive())
});